import {
    SYSTEM_CHOOSE_CURRENT_AREA,
} from './constants';
  
export function chooseCurrentArea(modal) {
    return {
      type: SYSTEM_CHOOSE_CURRENT_AREA,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case SYSTEM_CHOOSE_CURRENT_AREA:
        return {
          ...state,
          currentArea:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/system/redux/chooseCurrentArea.js